interface DateInputProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  name?: string;
  required?: boolean;
  error?: string;
  helperText?: string;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  testId?: string;
}

export function DateInput({
  label,
  value,
  onChange,
  name,
  required = false,
  error,
  helperText,
  onKeyDown,
  testId,
}: DateInputProps) {
  // Convert YYYYMMDD → YYYY-MM-DD (pure string, no Date object, no timezone issues)
  const toHTMLDate = (ediDate: string): string => {
    if (!ediDate || ediDate.length !== 8) return '';
    return `${ediDate.substring(0, 4)}-${ediDate.substring(4, 6)}-${ediDate.substring(6, 8)}`;
  };

  // Convert YYYY-MM-DD → YYYYMMDD (pure string, no Date object)
  const toEDIDate = (htmlDate: string): string => {
    if (!htmlDate) return '';
    // HTML date input always gives YYYY-MM-DD format
    return htmlDate.replace(/-/g, '');
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(toEDIDate(e.target.value));
  };

  return (
    <div className="flex flex-col">
      <label className="label-compact block">
        {label}
        {required && <span className="text-red-600 ml-1">*</span>}
      </label>
      <input
        type="date"
        name={name}
        value={toHTMLDate(value)}
        onChange={handleChange}
        onKeyDown={onKeyDown}
        data-testid={testId}
        className={`input-compact w-full border rounded-md transition-colors ${
          error ? 'border-red-500 focus:ring-red-500' : 'border-gray-300'
        }`}
      />
      {error && <p className="text-xs text-red-600 mt-1">{error}</p>}
      {helperText && !error && (
        <p className="text-xs text-gray-500 mt-1">{helperText}</p>
      )}
    </div>
  );
}
